import { Sheet } from "react-modal-sheet";

// Custom Icons
import SuccessIcon from "@/components/icons/SuccessIcon";
import WarningIcon from "@/components/icons/WarningIcon";
import ErrorIcon from "@/components/icons/ErrorIcon";
import InfoIcon from "@/components/icons/InfoIcon";

import { useThemeMode } from "@/contexts/ThemeContext";

const typeStyles = {
	success: {
		icon: <SuccessIcon />,
		color: "#2ecc71",
	},
	warning: {
		icon: <WarningIcon />,
		color: "#f39c12",
	},
	error: {
		icon: <ErrorIcon />,
		color: "#e74c3c",
	},
	info: {
		icon: <InfoIcon />,
		color: "#3498db",
	},
};

const NotificationSheet = ({
	open,
	onClose,
	type = "info",
	title = "",
	message = "",
	confirmText = "",
	cancelText = "Închide",
	withCancel = true,
	onConfirm = null,
	loading = false,
	imageUrl = "",
}) => {
	const hasButtons = withCancel || onConfirm;
	const buttonCount = (withCancel ? 1 : 0) + (onConfirm ? 1 : 0);

     const { isDarkMode } = useThemeMode(); 

	return (
		<Sheet isOpen={open} onClose={onClose} detent='content-height'>
			<Sheet.Container
				style={{
					borderTopLeftRadius: "16px",
					borderTopRightRadius: "16px",
					maxWidth: "auto",
					margin: "0 auto",
					transform: open ? "translateY(0)" : "translateY(100%)",
					opacity: open ? 1 : 0,
					transition: "transform 0.4s ease, opacity 0.3s ease",
                         backgroundColor: isDarkMode ? "#0d1015" : "#fff",
				}}
                    
			>
				<Sheet.Header />
				<Sheet.Content style={{ padding: "24px" }}>
					{imageUrl ? (
						<div style={{ textAlign: "center" }}>
							<img
								src={imageUrl}
								alt='Preview'
								style={{
									maxWidth: "100%",
									maxHeight: "70vh",
									borderRadius: "12px",
									boxShadow:
										"0 2px 8px rgba(0, 0, 0, 0.1)",
								}}
							/>
							{onConfirm && (
                                        <button
                                             onClick={onConfirm}
                                             disabled={loading}
                                             style={{
                                                  flex:
                                                       buttonCount ===
                                                       2
                                                            ? 1
                                                            : "none",
                                                  width:
                                                       buttonCount ===
                                                       1
                                                            ? "100%"
                                                            : undefined,
                                                  padding: "12px 24px",
                                                  borderRadius: "8px",
                                                  border: "none",
                                                  background:
                                                       typeStyles[
                                                            type
                                                       ].color,
                                                  color: "white",
                                                  cursor: "pointer",
                                                  fontSize: "16px",
                                                  fontWeight: "500",
                                                  opacity: loading
                                                       ? 0.7
                                                       : 1,
                                             }}
                                        >
                                             {loading
                                                  ? "Se trimite..."
                                                  : confirmText}
                                        </button>
                                   )}
						</div>
					) : (
					
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								textAlign: "center",
								padding: "24px",
							}}
						>
							<span
								style={{
									fontSize: "48px",
									marginBottom: "16px",
								}}
							>
								{typeStyles[type].icon}
							</span>

							<h3
								style={{
									margin: "0 0 10px 0",
									fontSize: "20px",
									fontWeight: "600",
									color: typeStyles[type].color,
								}}
							>
								{title}
							</h3>

							<p
								style={{
									margin: "0 0 32px 0",
									fontSize: "16px",
									lineHeight: "1.5",
									color: !isDarkMode ? "#333":"#fff",
								}}
							>
								{message}
							</p>

							{hasButtons && (
								<div
									style={{
										display: "flex",
										width: "100%",
										gap: "12px",
									}}
								>
									{withCancel && (
										<button
											onClick={onClose}
											style={{
												flex:
													buttonCount ===
													2
														? 1
														: "none",
												width:
													buttonCount ===
													1
														? "100%"
														: undefined,
												padding: "12px 24px",
												borderRadius: "8px",
												border: "1px solid #ddd",
												background: "white",
												color: "#333",
												cursor: "pointer",
												fontSize: "16px",
												fontWeight: "500",
											}}
										>
											{cancelText}
										</button>
									)}

									{onConfirm && (
										<button
											onClick={onConfirm}
											disabled={loading}
											style={{
												flex:
													buttonCount ===
													2
														? 1
														: "none",
												width:
													buttonCount ===
													1
														? "100%"
														: undefined,
												padding: "12px 24px",
												borderRadius: "8px",
												border: "none",
												background:
													typeStyles[
														type
													].color,
												color: "white",
												cursor: "pointer",
												fontSize: "16px",
												fontWeight: "500",
												opacity: loading
													? 0.7
													: 1,
											}}
										>
											{loading
												? "Se trimite..."
												: confirmText}
										</button>
									)}
								</div>
							)}
						</div>
					)}
				</Sheet.Content>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default NotificationSheet;
